/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Agsozialversicherung2Inputs */



/**

* @param {_Field_Agsozialversicherung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_agsozialversicherung2 = /** @type {((inputs?: _Field_Agsozialversicherung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Agsozialversicherung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("AG-Sozialversicherung")
});
export { _field_agsozialversicherung2 as "_field_agSozialVersicherung" }